<template>
  <div class="main-con el-main">
    <router-view />
  </div>
</template>

<script>
    export default {
        name: "ApplyingRepayment"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/ApplyingRepayment.vue